/**
 * The Gallery's videos being made, as the page keeps them: started here,
 * listed on load, and ended by the account's hub (its `video` frame). Pure,
 * so the hook stays thin.
 */

import type { GalleryItem, HubServerFrame, VideoJob } from '@wire';

export const VIDEO_FAILED = 'The video could not be made. Try again.';

type Ended = Extract<HubServerFrame, { t: 'video' }>;

/** A video ended: it leaves the ones being made, and a clip made goes first
 *  in the Gallery. `error` says when it did not come. */
export function withVideoEnded(
  s: { items: GalleryItem[]; videos: VideoJob[] },
  frame: Ended
): { items: GalleryItem[]; videos: VideoJob[]; error: string | null } {
  const videos = s.videos.filter((j) => j.id !== frame.job.id);
  if (!frame.item) return { items: s.items, videos, error: frame.job.status === 'failed' ? VIDEO_FAILED : null };
  return { items: [frame.item, ...s.items.filter((i) => i.id !== frame.item!.id)], videos, error: null };
}

/** After the hub reconnects: the videos still being made, as the server has
 *  them now, and whatever is new on the Gallery's first page first — a clip
 *  whose `video` frame went out while the page was not connected. */
export function withVideosResynced(
  s: { items: GalleryItem[]; videos: VideoJob[] },
  jobs: VideoJob[],
  first: GalleryItem[]
): { items: GalleryItem[]; videos: VideoJob[] } {
  const known = new Set(s.items.map((i) => i.id));
  return { items: [...first.filter((i) => !known.has(i.id)), ...s.items], videos: jobs };
}
